import React, { useState } from "react";
import { Loader2, LifeBuoy } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../../lib/api";
import { apiErr } from "../../../lib/apiErr";
import { ConfirmDialog } from "../../../components/ConfirmDialog";

export function FallbackSwitch({ value, onChanged }) {
  const [busy, setBusy] = useState(false);
  const [ask, setAsk] = useState(false);
  const save = async (next) => {
    setBusy(true);
    try { const r = await api.put("/admin/llm/settings", { emergent_fallback: next }); onChanged(r.data); toast.success(next ? "Cadangan Emergent diaktifkan" : "Cadangan Emergent dimatikan"); }
    catch (e) { toast.error(apiErr(e, "Gagal menyimpan")); } finally { setBusy(false); }
  };
  return (
    <div className="aivora-card flex flex-wrap items-center gap-4 p-5" data-testid="llm-fallback">
      <span className="hidden h-10 w-10 items-center justify-center rounded-xl bg-brand-soft text-brand sm:flex"><LifeBuoy size={18} /></span>
      <div className="min-w-0 basis-full sm:basis-auto sm:flex-1">
        <p className="text-sm font-bold text-slate-900">Cadangan Emergent Universal Key</p>
        <p className="mt-0.5 text-xs text-slate-500">Jika key sendiri tidak ada atau gagal, permintaan dialihkan ke Emergent. Jika dimatikan, fitur AI berhenti sementara dan kredit pengguna tidak dipotong.</p>
      </div>
      <button role="switch" aria-checked={value} disabled={busy} onClick={() => (value ? setAsk(true) : save(true))} data-testid="llm-fallback-toggle"
        className={`relative inline-flex h-7 w-12 shrink-0 items-center rounded-full transition-colors disabled:opacity-50 ${value ? "bg-emerald-500" : "bg-slate-300"}`}>
        <span className={`inline-block h-5 w-5 rounded-full bg-white shadow transition-transform ${value ? "translate-x-6" : "translate-x-1"}`} />
        {busy && <Loader2 size={12} className="absolute -right-5 animate-spin text-slate-400" />}
      </button>
      <span className={`text-xs font-bold ${value ? "text-emerald-600" : "text-slate-500"}`} data-testid="llm-fallback-state">{value ? "Aktif" : "Mati"}</span>
      <ConfirmDialog open={ask} testid="llm-fallback-confirm" title="Matikan cadangan Emergent?" confirmLabel="Ya, matikan"
        message="Jika key sendiri gagal, fitur AI akan berhenti sementara; tidak ada tagihan Emergent. Model khusus Emergent (Seedance) juga menjadi tidak tersedia."
        onCancel={() => setAsk(false)} onConfirm={() => { setAsk(false); save(false); }} />
    </div>
  );
}
